import { ResultsList } from './ResultsList';

/**
 * AI-Team "Results" tab — the cross-agent results archive. Mine / Shared /
 * (All, for founders) scope tabs live in ResultsList; this is just the mount.
 */
export function ResultsPanel() {
  return <ResultsList />;
}
